import { AuthenticationService } from './services/authentication.service';
import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DefaultLayoutComponent } from './components/layouts/default-layout/default-layout.component';
import { LoggedLayoutComponent } from './components/layouts/logged-layout/logged-layout.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [DefaultLayoutComponent, LoggedLayoutComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent {
  title = 'OET ALIA Tour';
  authenticated = computed(() => this.auth.authUser()?.exists() ?? false);

  constructor(private auth: AuthenticationService, private router: Router, translate: TranslateService) {
    translate.addLangs(['fr', 'en']);
    const lang = window.navigator.language ? window.navigator.language.split('-')[0] : 'en';
    translate.use(lang);

    this.router.events.subscribe(evt => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 500);
    });
  }
}
